// Copyright (c) 2016 Deere & Company

import SelectedDealers, {getDefaultState} from '../state/selected-dealers';
import actions from '../../actions-list';
import {updateList} from '../../../shared/services/list-selections';

const updateSelectedDealers = (state, action) =>
    SelectedDealers.update(state, {
        $set: updateList(
            action.dealer,
            action.isSelected,
            'account',
            state
        )
    });

const updateSelectAllDealers = (state, action) => {

    const dealers = state.length ? [] : action.dealers;

    return SelectedDealers.update(state, {
        $set: dealers
    });

};

const selectAllDealersOnLoad = (state, action) =>
    SelectedDealers.update(state, {
        $set: action.dealers
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.SELECT_ALL_MASS_CHANNEL_CUSTOMER_FOLLOWUP_DEALERS]: updateSelectAllDealers,
        [actions.SELECT_ALL_MASS_CHANNEL_CUSTOMER_FOLLOWUP_DEALERS_ON_LOAD]: selectAllDealersOnLoad,
        [actions.SELECT_MASS_CHANNEL_CUSTOMER_FOLLOWUP_DEALER]: updateSelectedDealers
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/mass-channel-customer-follow-up/reducers/selected-dealers.js